import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12px",
  height: "12px",
  viewBox: "0 0 12 12",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("title", null, "next", -1),
    _createElementVNode("g", {
      id: "Symbols",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", {
        id: "navigation/ic_next-black",
        fill: "#250E0E",
        "fill-rule": "nonzero"
      }, [
        _createElementVNode("path", {
          id: "Icon/NextBlack",
          d: "M9.39978204,2 C9.73110236,2 10,2.26889764 10,2.60021796 L10,6.85348243 C10,7.15639911 9.75443751,7.4019616 9.45152083,7.4019616 L9.34804326,7.4019616 C9.04512658,7.4019616 8.79956409,7.15639911 8.79956409,6.85348243 L8.79956409,4.0491441 L3.00935402,9.83935417 C2.79515958,10.0535486 2.44788178,10.0535486 2.23368734,9.83935417 L2.16064583,9.76631266 C1.94645139,9.55211822 1.94645139,9.20484042 2.16064583,8.99064598 L7.9508559,3.20043591 L5.14651757,3.20043591 C4.84360089,3.20043591 4.5980384,2.95487342 4.5980384,2.65195674 L4.5980384,2.54847917 C4.5980384,2.24556249 4.84360089,2 5.14651757,2 L9.39978204,2 Z",
          transform: "translate(6.000000, 6.000000) rotate(45.000000) translate(-6.000000, -6.000000) "
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }